(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["qroses-luxury-home"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const videos = [...document.querySelectorAll('video[data-qroses-home-video]')];
    if (!videos.length) return;
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    const automaticAllowed = () => !motion.matches && !connection?.saveData && !/^(slow-)?2g$/.test(connection?.effectiveType || '');
    const states = new Map();
    const draw = state => {
      state.button.setAttribute('aria-pressed', String(state.video.paused));
      state.button.setAttribute('aria-label', state.video.paused ? state.button.dataset.playLabel : state.button.dataset.pauseLabel);
      state.button.innerHTML = state.video.paused ? '▶' : '<span class="pause-mark" aria-hidden="true"></span>';
    };
    const mayPlay = state => !document.hidden && state.visible && !state.userPaused && (state.manual || automaticAllowed());
    const play = state => {
      if (!mayPlay(state)) return;
      const result = state.video.play();
      if (result?.catch) result.catch(() => draw(state));
    };
    const load = state => {
      const source = state.sources[state.sourceIndex];
      if (!source) return;
      state.loaded = true;
      state.video.muted = true;
      state.video.src = source.dataset.src;
      state.video.load();
      play(state);
    };
    const sync = state => {
      if (!mayPlay(state)) {
        state.video.pause();
        return;
      }
      if (state.loaded) {
        play(state);
        return;
      }
      if (state.scheduled) return;
      state.scheduled = true;
      const start = () => {
        state.scheduled = false;
        if (mayPlay(state)) load(state);
      };
      if (state.manual) start();
      else if ('requestIdleCallback' in window) window.requestIdleCallback(start, { timeout: 1000 });
      else window.setTimeout(start, 0);
    };
    videos.forEach(video => {
      const button = video.closest('section').querySelector('.video-toggle');
      const sources = [...video.querySelectorAll('source[data-src]')].filter(source => (!source.media || window.matchMedia(source.media).matches) && video.canPlayType(source.type));
      const state = { video, button, sources, sourceIndex: 0, visible: false, loaded: false, scheduled: false, userPaused: false, manual: false };
      states.set(video, state);
      video.addEventListener('play', () => draw(state));
      video.addEventListener('pause', () => draw(state));
      video.addEventListener('error', () => {
        if (state.sourceIndex + 1 < state.sources.length && mayPlay(state)) {
          state.sourceIndex += 1;
          load(state);
        } else draw(state);
      });
      button.addEventListener('click', () => {
        if (!video.paused) {
          state.userPaused = true;
          video.pause();
        } else {
          state.userPaused = false;
          state.manual = true;
          state.visible = true;
          sync(state);
        }
      });
      draw(state);
    });
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => entries.forEach(entry => {
        const state = states.get(entry.target);
        state.visible = entry.isIntersecting && entry.intersectionRatio >= 0.15;
        sync(state);
      }), { threshold: [0, 0.15], rootMargin: '0px' });
      videos.forEach(video => observer.observe(video));
    } else {
      let scheduled = false;
      const check = () => {
        scheduled = false;
        states.forEach(state => {
          const rect = state.video.getBoundingClientRect();
          state.visible = rect.bottom > 0 && rect.top < window.innerHeight;
          sync(state);
        });
      };
      window.addEventListener('scroll', () => {
        if (!scheduled) {
          scheduled = true;
          window.requestAnimationFrame(check);
        }
      }, { passive: true });
      check();
    }
    document.addEventListener('visibilitychange', () => states.forEach(sync));
    const policyChanged = () => states.forEach(state => {
      state.manual = false;
      sync(state);
    });
    motion.addEventListener('change', policyChanged);
    connection?.addEventListener('change', policyChanged);
    window.addEventListener('pagehide', () => videos.forEach(video => video.pause()));
  })();

  } catch(e) { console.error(e); }
})();
})();
